<template>
    <div>
        <div class="pc">
            <div class="right-bg"><img src="@/assets/newImages/common/common-icon.png" alt=""></div>
            <div class="content">
                <!-- 标题 -->
                <div class="con-header"><p>资料中心</p></div>
                <div class="con-main">
                    <div class="main-top">
                        <div class="main-three">
                            <div class="three flexCenter" v-for="(item, key) in threeList" :key="key" :class="{'three-active':threeIndex === key }" @click="chooseThree(key)"><div class="line"></div><p>{{item.one}}</p><span></span></div>
                        </div>
                        <div class="right">
                            <div class="input-div" v-if="threeIndex==1">
                                <input type="text" name="" v-model="specialKeywords" @keyup.enter="doSearchSpecial()" id="" placeholder="请输入关键字搜索">
                                <div class="search" @click="doSearchSpecial()"><img src="@/assets/newImages/hotNews/search.png" alt="search"></div>
                            </div>
                            <div class="input-div" v-if="threeIndex==2">
                                <input type="text" name="" v-model="hallKeywords" @keyup.enter="doSearchHall()" id="" placeholder="请输入关键字搜索">
                                <div class="search" @click="doSearchHall()"><img src="@/assets/newImages/hotNews/search.png" alt="search"></div>
                            </div>
                            <!-- 筛选 -->
                            <div class="box" v-if="threeIndex==1 || threeIndex==2">
                                <div class="screen-right"  v-if="screenPop==false" @click="screenPop=true">
                                    <p>展开筛选</p>
                                    <img src="@/assets/newImages/parnter/title-icon2.png" alt="">
                                </div>
                                <div class="screen-right screen-active" v-if="screenPop==true" @click="screenPop=false">
                                    <p>收起筛选</p>
                                    <img src="@/assets/newImages/parnter/title-icon3.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 专题演讲筛选 -->
                    <div  v-if="threeIndex==1">
                        <div class="screen-main" v-if="screenPop==true">
                            <div class="screen-bg"><img src="@/assets/newImages/agenda/pop-bg.png" alt=""></div>
                            <div class="title"><div class="red-line"></div><p>内容类别</p></div>
                            <div class="content-main" :style="{maxHeight:screenHeight}">
                                <div class="title-line" v-for="(filterItem, index) in specialFilter" :key="index">
                                    <div class="text-name">{{filterItem.name}}</div>
                                    <div class="choose-nav">
                                        <div class="choose-nav-one" v-for="(navOne, key) in filterItem.child[Object.keys(filterItem.child)[0]]" :key="key" @click="chooseFilter(filterItem.name+'$'+navOne.name)">
                                            <div class="img">
                                                <img v-if="specialFilterArr.indexOf(filterItem.name+'$'+navOne.name) == -1" src="@/assets/newImages/agenda/choose1.png" alt="">
                                                <img v-if="specialFilterArr.indexOf(filterItem.name+'$'+navOne.name) != -1" src="@/assets/newImages/agenda/choose2.png" alt="">
                                            </div>
                                            <p>{{navOne.name}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="button-line">
                                <div class="button" @click="setSpecialChoose()">重置</div>
                                <div class="button" @click="submitSpecialChoose()">确认</div>
                            </div>
                        </div> 
                    </div>
                    <!--展区筛选 -->
                    <div v-if="threeIndex==2">
                        <div class="screen-main2" v-if="screenPop==true">
                            <div class="bg"><img src="@/assets/newImages/file/screen-bg.png" alt=""></div>
                            <div class="title"><div class="red-line"></div><p>内容类别</p></div>
                            <div class="content-main2">
                                <div class="choose-one" v-for="(item,index) in hallFilter" :key="index" @click="chooseHallFilter(item)">
                                    <div class="one-img">
                                        <img src="@/assets/newImages/agenda/choose1.png" alt="" v-if="hallFilterArr.indexOf(item) == -1">
                                        <img src="@/assets/newImages/agenda/choose2.png" alt="" v-if="hallFilterArr.indexOf(item) != -1">
                                    </div>
                                    <p>{{item}}</p>
                                </div>
                            </div>
                            <div class="button-line">
                                <div class="submit" @click="setHallChoose()">重置</div>
                                <div class="submit" @click="submitHallChoose()">确认</div>
                            </div>
                        </div>
                    </div>
                    <div class="main" :style="{height:pageHeight}">
                        <div class="main-list">
                            <div class="main-list-one" v-if="threeIndex==0">
                                <div class="one-list1" v-for="(file,index) in fileList" :key="index">
                                    <div class="title" @click="chooseFileShow(index)">
                                        <div class="left"><p></p><p>{{file.title}}</p></div>
                                        <div class="right">
                                            <div class="r-button" @click.stop="topicDownloadAll(index)">
                                            <div class="r-img"><img src="@/assets/newImages/file/icon.png" alt=""></div>
                                                <p>全部下载</p> 
                                            </div>
                                            <div class="r-button2"  :class="{'more-active':file.fileShow==true}"><img src="@/assets/newImages/file/icon3.png" alt=""></div>
                                        </div>
                                    </div>
                                    <div class="pdf" v-if="file.fileShow ">
                                        <div class="item" v-for="(item,id) in file.fileMain" :key="id">
                                            <div class="item-left">
                                                <div class="left"><img src="@/assets/newImages/file/icon4.png" alt=""></div>
                                                    <p>{{item.name}}</p>
                                                </div>
                                            <div class="item-right">
                                                <div class="right-but" @click="preview(item, file)">
                                                    <div class="but-img"><img src="@/assets/newImages/file/icon2.png" alt=""></div>
                                                    <p>在线预览</p> 
                                                </div>
                                                <div class="right-but" @click="download(item, file)">
                                                    <div class="but-img2"><img src="@/assets/newImages/file/icon.png" alt=""></div>
                                                    <p>资料下载</p> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="main-list-one" v-if="threeIndex==1&&specialList.length>0">
                                <div class="one-list1" v-for="(special,key) in specialList" :key="key">
                                    <div class="title" @click="specialClick(key)">
                                        <div class="left"><p></p><p>{{special.title}}</p></div>
                                        <div class="right">
                                            <div class="r-button" @click.stop="specialDownloadAll(special.specialMain, special)">
                                            <div class="r-img"><img src="@/assets/newImages/file/icon.png" alt=""></div>
                                                <p>全部下载</p> 
                                            </div>
                                            <div class="r-button2" :class="{'more-active':special.specialShow==true}"><img src="@/assets/newImages/file/icon3.png" alt=""></div>
                                        </div>
                                    </div>
                                    <div class="pdf" v-if="special.specialShow">
                                        <div class="item" v-for="(item,id) in special.specialMain" :key="id">
                                            <div class="item-left">
                                                <div class="left"><img src="@/assets/newImages/file/icon4.png" alt=""></div>
                                                    <p>{{item.name}}</p>
                                                </div>
                                            <div class="item-right">
                                                <div class="right-but" @click.stop="specialPreview(item, special)">
                                                    <div class="but-img"><img src="@/assets/newImages/file/icon2.png" alt=""></div>
                                                    <p>在线预览</p> 
                                                </div>
                                                <div class="right-but" @click.stop="specialDownload(item, special)">
                                                    <div class="but-img2"><img src="@/assets/newImages/file/icon.png" alt=""></div>
                                                    <p>资料下载</p> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="main-list-one flexCenter" v-if="threeIndex==1&&specialList.length==0">
                                <p style="color:gray;font-size:24px;margin:auto;">暂无您要搜索的内容</p>
                            </div>
                            <div class="main-list-one" v-if="threeIndex==2&&hallList.length>0">
                                <div class="one-list1" v-for="(hall,id) in hallList" :key="id">
                                    <div class="title" @click="choosehallShow(id, hall.folderId)">
                                        <div class="left"><p></p><p>{{hall.title}}</p></div>
                                        <div class="right">
                                            <div class="r-button" @click.stop="hallDownloadAll(hall.folderId, hall)">
                                            <div class="r-img"><img src="@/assets/newImages/file/icon.png" alt=""></div>
                                                <p>全部下载</p> 
                                            </div>
                                            <div class="r-button2"  :class="{'more-active':hall.isShow==true}"><img src="@/assets/newImages/file/icon3.png" alt=""></div>
                                        </div>
                                    </div>
                                    <div class="pdf" v-if="hall.isShow ">
                                        <div class="item" v-for="(item,id) in hall.hallMain" :key="id">
                                            <div class="item-left">
                                                <div class="left3"><img src="@/assets/newImages/file/icon5.png" alt=""></div>
                                                    <p>{{item.name}}</p>
                                                </div>
                                            <div class="item-right">
                                                <div class="right-but" @click.stop="preview(item, hall)">
                                                    <div class="but-img"><img src="@/assets/newImages/file/icon2.png" alt=""></div>
                                                    <p>在线预览</p> 
                                                </div>
                                                <div class="right-but" @click.stop="download(item, hall)">
                                                    <div class="but-img2"><img src="@/assets/newImages/file/icon.png" alt=""></div>
                                                    <p>资料下载</p> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="main-list-one flexCenter" v-if="threeIndex==2&&hallList.length==0">
                                <p style="color:gray;font-size:24px;margin:auto;">暂无您要搜索的内容</p>
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="wap">
            <div class="page-img"><img src="@/assets/newImages/common/navWap/page-img.png" alt=""></div>
            <div class="content">
                <!-- 标题 -->
                <div class="con-header"><p>资料中心</p></div>
                <div class="con-main">
                    <div class="main-top2" v-if="threeIndex==1 || threeIndex==2">
                        <div class="input-div" v-if="threeIndex==1">
                            <input type="text" name="" v-model="specialKeywords" @keyup.enter="doSearchSpecial()" id="" placeholder="请输入关键字搜索">
                            <div class="search" @click="doSearchSpecial()"><img src="@/assets/newImages/hotNews/search.png" alt="search"></div>
                        </div>
                        <div class="input-div" v-if="threeIndex==2">
                            <input type="text" name="" v-model="hallKeywords" @keyup.enter="doSearchHall()" id="" placeholder="请输入关键字搜索">
                            <div class="search" @click="doSearchHall()"><img src="@/assets/newImages/hotNews/search.png" alt="search"></div>
                        </div>
                        <!-- 筛选 -->
                        <div class="box">
                            <div class="screen-right"  v-if="screenPop==false" @click="screenPop=true">
                                <p>展开筛选</p>
                                <img src="@/assets/newImages/parnter/title-icon2.png" alt="">
                            </div>
                            <div class="screen-right screen-active" v-if="screenPop==true" @click="screenPop=false">
                                <p>收起筛选</p>
                                <img src="@/assets/newImages/parnter/title-icon3.png" alt="">
                            </div>
                        </div>
                    </div>
                    <!-- 专题演讲筛选 -->
                    <div  v-if="threeIndex==1">
                        <div class="screen-main" v-if="screenPop==true">
                            <div class="screen-bg"><img src="@/assets/newImages/agenda/pop-bg.png" alt=""></div>
                            <div class="title"><div class="red-line"></div><p>内容类别</p></div>
                            <div class="content-main" :style="{maxHeight:screenHeight}">
                                <div class="title-line" v-for="(filterItem, index) in specialFilter" :key="index">
                                    <div class="text-name">{{filterItem.name}}</div>
                                    <div class="choose-nav">
                                        <div class="choose-nav-one" v-for="(navOne, key) in filterItem.child[Object.keys(filterItem.child)[0]]" :key="key" @click="chooseFilter(filterItem.name+'$'+navOne.name)">
                                            <div class="img">
                                                <img v-if="specialFilterArr.indexOf(filterItem.name+'$'+navOne.name) == -1" src="@/assets/newImages/agenda/choose1.png" alt="">
                                                <img v-if="specialFilterArr.indexOf(filterItem.name+'$'+navOne.name) != -1" src="@/assets/newImages/agenda/choose2.png" alt="">
                                            </div>
                                            <p>{{navOne.name}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="button-line">
                                <div class="button" @click="setSpecialChoose()">重置</div>
                                <div class="button" @click="submitSpecialChoose()">确认</div>
                            </div>
                        </div> 
                    </div>
                    <!--展区筛选 -->
                    <div v-if="threeIndex==2">
                        <div class="screen-main2" v-if="screenPop==true">
                            <div class="bg"><img src="@/assets/newImages/file/screen-bg.png" alt=""></div>
                            <div class="title"><div class="red-line"></div><p>内容类别</p></div>
                            <div class="content-main2">
                                <div class="choose-one" v-for="(item,index) in hallFilter" :key="index" @click="chooseHallFilter(item)">
                                    <div class="one-img">
                                        <img src="@/assets/newImages/agenda/choose1.png" alt="" v-if="hallFilterArr.indexOf(item) == -1">
                                        <img src="@/assets/newImages/agenda/choose2.png" alt="" v-if="hallFilterArr.indexOf(item) != -1">
                                    </div>
                                    <p>{{item}}</p>
                                </div>
                            </div>
                            <div class="button-line">
                                <div class="submit" @click="setHallChoose()">重置</div>
                                <div class="submit" @click="submitHallChoose()">确认</div>
                            </div>
                        </div>
                    </div>
                    <!-- tab -->
                    <div class="main-three">
                        <div class="three flexCenter" v-for="(item, key) in threeList" :key="key" :class="{'three-active':threeIndex === key }" @click="chooseThree(key)"><div class="line"></div><p>{{item.one}}</p><span></span></div>
                    </div>
                    <!-- 内容 -->
                    <div class="main">
                        <div class="main-list">
                            <div class="main-list-one" v-if="threeIndex==0">
                                <div class="one-list1" v-for="(file,index) in fileList" :key="index">
                                    <div class="title" @click="chooseFileShow(index)">
                                        <div class="left"><p></p><p>{{file.title}}</p></div>
                                        <div class="right">
                                            <div class="r-button" @click.stop="topicDownloadAll(index)">
                                            <div class="r-img"><img src="@/assets/newImages/file/icon.png" alt=""></div>
                                                <p>全部下载</p> 
                                            </div>
                                            <div class="r-button2"  :class="{'more-active':file.fileShow==true}"><img src="@/assets/newImages/file/icon3.png" alt=""></div>
                                        </div>
                                    </div>
                                    <div class="pdf" v-if="file.fileShow ">
                                        <div class="item" v-for="(item,id) in file.fileMain" :key="id">
                                            <div class="item-left">
                                                <div class="left"><img src="@/assets/newImages/file/icon4.png" alt=""></div>
                                                    <p>{{item.name}}</p>
                                                </div>
                                            <div class="item-right">
                                                <div class="right-but" @click.stop="preview(item, file)">
                                                    <div class="but-img"><img src="@/assets/newImages/file/icon2.png" alt=""></div>
                                                    <p>在线预览</p> 
                                                </div>
                                                <div class="right-but" @click.stop="download(item, file)">
                                                    <div class="but-img2"><img src="@/assets/newImages/file/icon.png" alt=""></div>
                                                    <p>资料下载</p> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="main-list-one" v-if="threeIndex==1&&specialList.length>0">
                                <div class="one-list1" v-for="(special,key) in specialList" :key="key">
                                    <div class="title" @click="specialClick(key)">
                                        <div class="left"><p></p><p>{{special.title}}</p></div>
                                        <div class="right">
                                            <div class="r-button" @click.stop="specialDownloadAll(special.specialMain, special)">
                                            <div class="r-img"><img src="@/assets/newImages/file/icon.png" alt=""></div>
                                                <p>全部下载</p> 
                                            </div>
                                            <div class="r-button2"  :class="{'more-active':special.specialShow==true}"><img src="@/assets/newImages/file/icon3.png" alt=""></div>
                                        </div>
                                    </div>
                                    <div class="pdf" v-if="special.specialShow ">
                                        <div class="item" v-for="(item,id) in special.specialMain" :key="id">
                                            <div class="item-left">
                                                <div class="left"><img src="@/assets/newImages/file/icon4.png" alt=""></div>
                                                    <p>{{item.name}}</p>
                                                </div>
                                            <div class="item-right">
                                                <div class="right-but" @click.stop="specialPreview(item, special)">
                                                    <div class="but-img"><img src="@/assets/newImages/file/icon2.png" alt=""></div>
                                                    <p>在线预览</p> 
                                                </div>
                                                <div class="right-but" @click.stop="specialDownload(item, special)">
                                                    <div class="but-img2"><img src="@/assets/newImages/file/icon.png" alt=""></div>
                                                    <p>资料下载</p> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="main-list-one main-list-one-div flexCenter" v-if="threeIndex==1&&specialList.length==0">
                                <p style="color:gray;font-size:16px;margin:auto;">暂无您要搜索的内容</p>
                            </div>
                            <div class="main-list-one" v-if="threeIndex==2&&hallList.length>0">
                                <div class="one-list1" v-for="(hall,id) in hallList" :key="id">
                                    <div class="title" @click="choosehallShow(id, hall.folderId)">
                                        <div class="left"><p></p><p>{{hall.title}}</p></div>
                                        <div class="right">
                                            <div class="r-button" @click.stop="hallDownloadAll(hall.folderId, hall)">
                                            <div class="r-img"><img src="@/assets/newImages/file/icon.png" alt=""></div>
                                                <p>全部下载</p> 
                                            </div>
                                            <div class="r-button2" :class="{'more-active':hall.isShow==true}"><img src="@/assets/newImages/file/icon3.png" alt=""></div>
                                        </div>
                                    </div>
                                    <div class="pdf" v-if="hall.isShow">
                                        <div class="item" v-for="(item,id) in hall.hallMain" :key="id">
                                            <div class="item-left">
                                                <div class="left3"><img src="@/assets/newImages/file/icon5.png" alt=""></div>
                                                    <p>{{item.name}}</p>
                                                </div>
                                            <div class="item-right">
                                                <div class="right-but" @click.stop="preview(item, hall)">
                                                    <div class="but-img"><img src="@/assets/newImages/file/icon2.png" alt=""></div>
                                                    <p>在线预览</p> 
                                                </div>
                                                <div class="right-but" @click.stop="download(item, hall)">
                                                    <div class="but-img2"><img src="@/assets/newImages/file/icon.png" alt=""></div>
                                                    <p>资料下载</p> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="main-list-one main-list-one-div flexCenter" v-if="threeIndex==2&&hallList.length==0">
                                <p style="color:gray;font-size:16px;margin:auto;">暂无您要搜索的内容</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <registerPop :registerPop="registerPop" @registerPopClose="registerPopClose" @goRegister="goRegister"></registerPop>
    <downloadFilePop :downloadFilePop="downloadFilePop" :downloadFilePopMsg="downloadFilePopMsg" @closeDownLoadPop="closeDownLoadPop" @sendEmail="sendEmail"></downloadFilePop>
    <downloadFileSuccessPop :downloadFileSuccessPop="downloadFileSuccessPop" @downloadFilePopClose="downloadFilePopClose"></downloadFileSuccessPop>
    </div>
</template>

<script>
import registerPop from 'components/registerPop';
import downloadFilePop from 'components/downloadFilePop';
import downloadFileSuccessPop from 'components/downloadFileSuccessPop';
import api from '../api';
import { sortKey, goSignup, previewFile } from '@/utils/tool';
export default {
    components: {
        registerPop, downloadFilePop, downloadFileSuccessPop
    },
    data(){
        return{
            pageHeight:'',
            height:document.documentElement.clientHeight,
            width:document.documentElement.clientWidth,
            threeList:[{one:"主题演讲"},{one:"专题演讲"},{one:"展区"}],
            threeIndex:0,//默认主题演讲
            fileList:[],
            specialList:[],
            specialListOri:[],
            hallList:[
                {title:'智能微卡口1',isShow:false,hallMain:[{name:'ADT Network Operating System(ANOS)-轻松管理您的网络.pdf'},{name:'2021华为生态伙伴大会获取资料：行业.pdf'},{name:'华为发布政务云大数据解决方案，助力政府数字化转型.pdf'}]},
                {title:'智能微卡口1',isShow:false,hallMain:[{name:'ADT Network Operating System(ANOS)-轻松管理您的网络.pdf'},{name:'2021华为生态伙伴大会获取资料：行业.pdf'},{name:'华为发布政务云大数据解决方案，助力政府数字化转型.pdf'}]},
                {title:'智能微卡口1',isShow:false,hallMain:[{name:'ADT Network Operating System(ANOS)-轻松管理您的网络.pdf'},{name:'2021华为生态伙伴大会获取资料：行业.pdf'},{name:'华为发布政务云大数据解决方案，助力政府数字化转型.pdf'}]},
                {title:'智能微卡口1',isShow:false,hallMain:[{name:'ADT Network Operating System(ANOS)-轻松管理您的网络.pdf'},{name:'2021华为生态伙伴大会获取资料：行业.pdf'},{name:'华为发布政务云大数据解决方案，助力政府数字化转型.pdf'}]},
                {title:'智能微卡口1',isShow:false,hallMain:[{name:'ADT Network Operating System(ANOS)-轻松管理您的网络.pdf'},{name:'2021华为生态伙伴大会获取资料：行业.pdf'},{name:'华为发布政务云大数据解决方案，助力政府数字化转型.pdf'}]},
            ],
            hallListOri: [],
            screenPop:false,//筛选菜单
            screenHeight:'',
            filter:[],
            filter2:[{class:'行业',ischoose:false},{class:'产业',ischoose:false},{class:'生态',ischoose:false}],//筛选类别
            email:'',// 邮箱
            message:'',
            // 成功的邮箱
            successShow:false,
            hallKeywords: '',
            specialKeywords: '',
            registerPop: false,
            downloadFilePop: false,
            downloadFilePopMsg: '',
            downloadFileSuccessPop: false,
            downloadFileId: [],
            downloadFileName: '',
            emailRequest: false,
            specialFilter: [],
            specialFilterArr: [],
            hallFilter: [],
            hallFilterArr: [],
        }
    },
    created(){
        this.showHeight();
        this.getAgendaList();
        this.initSpecialFilter();
        this.getExtHall();
    },
    computed:{
    },
    methods: {
        // 内容有效区域高度
        showHeight(){
            this.pageHeight = this.height-252/1920*this.width-63/1920*this.width+"px",
            this.screenHeight = this.height-245/1920*this.width-128/1920*this.width-186/1920*this.width-38/1920*this.width+"px"
        },
        // 切换tab
        chooseThree(index){
            this.threeIndex = index;

            // 埋码
            this.$maima.material_page_top_tab_click(this.threeList[this.threeIndex].one);
        },
        // 主题演讲
        chooseFileShow(index){
            this.fileList.forEach((item,num)=>{
                if(num== index){
                    this.fileList[num].fileShow=!this.fileList[num].fileShow
                }
            })
        },
        // 专题演讲
        specialClick(key){
            let data = this.specialList;
            data.map((item, index)=>{
                if(key == index){
                    item.specialShow = ! item.specialShow;
                }
            })
            this.specialList = data;
            // this.specialList.forEach((item,num)=>{
            //     if(num== key){
            //         this.specialList[num].specialShow=!this.specialList[num].specialShow
            //     }
            // })
        },
        // 展厅数据展开
        async choosehallShow(id, folderId){
            let res = await api.getFileFolder(folderId);
            this.hallList.forEach((item,num)=>{
                if(num== id){
                    this.hallList[num].isShow=!this.hallList[num].isShow;
                    this.hallList[num].hallMain=res;
                }
            })
        },
        // 邮箱
        emailBlur(){
            var reg = /^[A-Za-z0-9]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                if (!reg.test(this.email)) {
                    this.message = '邮箱格式错误, 请重新输入'
                } else {
                    this.successShow = true
                }
        },
        // 确认
        submitChoose2(){
            this.screenPop=false;
        },
        // 专题演讲
        chooseFilter(num1,num2){
            this.filter.forEach((item,index)=>{
                if(num1==index){
                    item.navList.forEach((list,key)=>{
                        if(num2==key){
                            this.filter[index].navList[key].choose=!list.choose
                        }
                    })
                }
            })
        },
        setChoose(){
            this.filter.forEach((item,index)=>{
                item.navList.forEach((list,key)=>{
                    this.filter[index].navList[key].choose=false
                })
            })
        },
        submitChoose(){
            this.screenPop=false;
        },
        // 获取主题演讲议程
        getAgendaList(){
            let that = this;
            api.getNewSubSeminarList()
            .then(res=>{
                if(res){
                    that.getTopicFiles(res);
                    that.getSpecialFiles(res);
                }
            })
            .catch(err=>{
                that.$store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
            });
        },
        // 获取主题演讲议程文件
        getTopicFiles(res){
            let that = this;

            let data = [];
            if(res.first.topic.length>0){
                data.push({
                    title: res.first.topic[0].name,
                    m_industry_tag: res.first.topic[0].m_industry_tag,
                    m_product_tag: res.first.topic[0].m_product_tag,
                    fileShow: false,
                    fileMain: [],
                });
            }
            if(res.second.topic.length>0){
                res.second.topic.map(item=>{
                    data.push({
                        title: item.name,
                        m_industry_tag: item.m_industry_tag,
                        m_product_tag: item.m_product_tag,
                        fileShow: false,
                        fileMain: [],
                    });
                });
            }
            that.fileList = data;

            // 17日
            api.getFileFolder(window.$config.files.topic17FolderId)
            .then(res=>{
                that.fileList[0].fileMain = sortKey(res, 'order');
            })
            .catch(err=>{
                that.$store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
            });

            // 18日-1
            api.getFileFolder(window.$config.files.topic181FolderId)
            .then(res=>{
                that.fileList[1].fileMain = sortKey(res, 'order');
            })
            .catch(err=>{
                that.$store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
            });

            // 18日-2
            api.getFileFolder(window.$config.files.topic182FolderId)
            .then(res=>{
                that.fileList[2].fileMain = sortKey(res, 'order');
            })
            .catch(err=>{
                that.$store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
            });
        },
        // 获取专题演讲议程文件
        getSpecialFiles(res){
            let subSeminarIds = [];
            let special = {};
            res.first.special.map(item=>{
                subSeminarIds.push(item.subSeminarId);
                special[item.subSeminarId] = item;
                // item.agendaListData.map(childItem=>{
                //     subSeminarIds.push(childItem.agendaId);
                // });
            });
            res.second.special.map(item=>{
                subSeminarIds.push(item.subSeminarId);
                special[item.subSeminarId] = item;
                // item.agendaListData.map(childItem=>{
                //     subSeminarIds.push(childItem.agendaId);
                // });
            });
            let that = this;
            api.querySpecialTopicFiles(subSeminarIds)
            .then(res=>{
                if(res.result == 0){
                    let data = res.content.content;
                    let specialList = [];
                    for(let key in data){
                        specialList.push({
                            title: special[key].name,
                            order: special[key].i_subSeminarOrder,
                            seoWords: special[key].seoWords,
                            m_filterTag: special[key].m_filterTag,
                            specialShow: false,
                            specialMain: data[key],
                            m_industry_tag: special[key].m_industry_tag,
                            m_product_tag: special[key].m_product_tag,
                        });
                    }
                    that.specialList = sortKey(specialList, 'order');
                    that.specialListOri = sortKey(specialList, 'order');
                }
            })
            .catch(err=>{
            });
        },
        initSpecialFilter(){
            let that = this;
            api.getSubSeminarFilterData()
            .then(res=>{
                if(res){
                    this.specialFilter = res;
                }
            })
            .catch(err=>{
            });
        },
        chooseFilter(name=''){
            if(this.specialFilterArr.indexOf(name) != -1){
                let temp = [];
                this.specialFilterArr.map(item=>{
                    if(item != name){
                        temp.push(item);
                    }
                });
                this.specialFilterArr = temp;
            }else{
                this.specialFilterArr.push(name);
            }
        },
        // 专题演讲筛选重置
        setSpecialChoose(){
            this.specialFilterArr = [];
        },
        // 专题演讲筛选确认
        submitSpecialChoose(){
            this.doSearchSpecial();
            this.screenPop=false;
        },
        // 专题演讲搜索
        doSearchSpecial(){
            let data = this.specialListOri,
                temp = [];

            if(!this.specialKeywords && this.specialFilterArr.length == 0){
                temp = data;
            }else{
                let keyWordsMatch = false,
                    filterMatch = false;
                data.map(item=>{
                    if(this.specialKeywords && item.seoWords.indexOf(this.specialKeywords) != -1){
                        keyWordsMatch = true;
                    }

                    if(this.specialFilterArr.length > 0 && this.specialFilterArr.indexOf(item.m_filterTag) != -1){
                        filterMatch = true;
                    }

                    if(this.specialKeywords && this.specialFilterArr.length == 0 && keyWordsMatch){
                        temp.push(item);
                    }else if(!this.specialKeywords && this.specialFilterArr.length > 0 && filterMatch){
                        temp.push(item);
                    }else if(this.specialKeywords && this.specialFilterArr.length > 0 && keyWordsMatch && filterMatch){
                        temp.push(item);
                    }

                    keyWordsMatch = false;
                    filterMatch = false;
                });
            }
            this.specialList = temp;

            // 埋码
            this.$maima.material_page_content_confirm_click(this.specialKeywords + '^' + this.specialFilterArr.join('^'));
        },
        // 展厅数据
        getExtHall(){
            let that = this;
            api.getExthallList()
            .then(res=>{
                let nameArr = [];
                let hallArr = [];
                res.map(item=>{
                    item.tagName = item.cateName.replace('馆', '');
                    nameArr.push(item.tagName);
                    item.child.map(childItem=>{
                        hallArr.push({
                            title: childItem.title,
                            cateTag: item.tagName,
                            folderId: childItem.folderId,
                            seoWords: childItem.seoWords,
                            m_product_tag: childItem.m_product_tag,
                            m_industry_tag: childItem.m_industry_tag,
                            isShow: false,
                            hallMain: []
                        });
                    });
                });
                that.hallFilter = nameArr;
                that.hallList = sortKey(hallArr, 'orderNumber');
                that.hallListOri = sortKey(hallArr, 'orderNumber');
            })
            .catch(err=>{
            });
        },
        chooseHallFilter(name){
            if(this.hallFilterArr.indexOf(name) != -1){
                let temp = [];
                this.hallFilterArr.map(item=>{
                    if(item != name){
                        temp.push(item);
                    }
                });
                this.hallFilterArr = temp;
            }else{
                this.hallFilterArr.push(name);
            }
        },
        // 展区筛选重置
        setHallChoose(){
            this.hallFilterArr = [];
        },
        // 展区筛选确认
        submitHallChoose(){
            this.doSearchHall();
            this.screenPop=false;
        },
        // 展区搜索
        doSearchHall(){
            let data = this.hallListOri,
                temp = [];

            if(!this.hallKeywords && this.hallFilterArr.length == 0){
                temp = data;
            }else{
                let keyWordsMatch = false,
                    filterMatch = false;
                data.map(item=>{
                    if(this.hallKeywords && item.seoWords.indexOf(this.hallKeywords) != -1){
                        keyWordsMatch = true;
                    }

                    if(this.hallFilterArr.length > 0 && this.hallFilterArr.indexOf(item.cateTag) != -1){
                        filterMatch = true;
                    }

                    if(this.hallKeywords && this.hallFilterArr.length == 0 && keyWordsMatch){
                        temp.push(item);
                    }else if(!this.hallKeywords && this.hallFilterArr.length > 0 && filterMatch){
                        temp.push(item);
                    }else if(this.hallKeywords && this.hallFilterArr.length > 0 && keyWordsMatch && filterMatch){
                        temp.push(item);
                    }

                    keyWordsMatch = false;
                    filterMatch = false;
                });
            }
            this.hallList = temp;

            // 埋码
            this.$maima.material_page_content_confirm_click(this.hallKeywords + '^' + this.hallFilterArr.join('^'));
        },
        showRegister(){
                this.registerPop = true;
        },
        registerPopClose(){
            this.registerPop = false;
        },
        goRegister(){
            goSignup('online', this.$route.query.shareKey, true);
        },
        preview(file, data){
            // if(!this.$store.state.userLogin){
            //     this.showRegister();
            //     return;
            // }

            if(!file){
                return;
            }

            // 埋码
            this.$maima.material_page_onlinereview_click(file.name, this.threeList[this.threeIndex].one, data.m_product_tag, data.m_industry_tag);
            
            if(file.ext == 'temp'){
                return;
            }else{
                previewFile(file.fileUrl);
                return;
            }
        },
        specialPreview(item, data){
            // if(!this.$store.state.userLogin){
            //     this.showRegister();
            //     return;
            // }

            if(!item){
                return;
            }

            // 埋码
            this.$maima.material_page_onlinereview_click(item.name, this.threeList[this.threeIndex].one, data.m_product_tag, data.m_industry_tag);
            
            previewFile(item.url.replace('http://', 'https://') + '&type=download&isPreview=1');
            return;
        },
        download(file, data){

            // 埋码
            this.$maima.material_page_download_click(file.name, this.threeList[this.threeIndex].one, data.m_product_tag, data.m_industry_tag);

            if(!this.$store.state.userLogin){
                this.showRegister();
                return;
            }

            if(!file){
                return;
            }

            if(file.ext == 'temp'){
                return;
            }else{
                this.downloadFileId = [file.fileId];
                this.downloadFileName = file.name;
                this.showDownloadPop();
                return;
            }
        },
        specialDownload(item, data){

            // 埋码
            this.$maima.material_page_download_click(item.name, this.threeList[this.threeIndex].one, data.m_product_tag, data.m_industry_tag);

            if(!this.$store.state.userLogin){
                this.showRegister();
                return;
            }

            if(!item){
                return;
            }

            this.downloadFileId = [item.fileId];
            this.downloadFileName = item.name;
            this.showDownloadPop();
            return;
        },
        topicDownloadAll(key){
            if(!this.$store.state.userLogin){
                this.showRegister();
                return;
            }

            let files = [];
            let fileNames = '';
            let fileNamesArr = [];
            this.fileList[key].fileMain.map(item=>{
                if(item.ext != 'temp'){
                    files.push(item.fileId);
                    fileNamesArr.push(item.name);
                }
            });
            fileNames = fileNamesArr.join('^');


            // 埋码
            this.$maima.material_page_downloadall_click(fileNames, this.threeList[this.threeIndex].one, this.fileList[key].m_product_tag, this.fileList[key].m_industry_tag);

            if(files.length == 0){
                return;
            }else{
                this.downloadFileId = files;
                this.downloadFileName = fileNames;
                this.showDownloadPop();
                return;
            }
        },
        specialDownloadAll(data, item){
            if(!this.$store.state.userLogin){
                this.showRegister();
                return;
            }

            let files = [];
            let fileNames = '';
            let fileNamesArr = [];
            data.map(item=>{
                files.push(item.fileId);
                fileNamesArr.push(item.name);
            });
            fileNames = fileNamesArr.join('^');


            // 埋码
            this.$maima.material_page_downloadall_click(fileNames, this.threeList[this.threeIndex].one, item.m_product_tag, item.m_industry_tag);

            if(files.length == 0){
                return;
            }else{
                this.downloadFileId = files;
                this.downloadFileName = fileNames;
                this.showDownloadPop();
                return;
            }
        },
        async hallDownloadAll(folderId, hall){
            if(!this.$store.state.userLogin){
                this.showRegister();
                return;
            }

            let res = await api.getFileFolder(folderId);

            let files = [];
            let fileNames = '';
            let fileNamesArr = [];
            res.map(item=>{
                files.push(item.fileId);
                fileNamesArr.push(item.name);
            });
            fileNames = fileNamesArr.join('^');

            // 埋码
            this.$maima.material_page_downloadall_click(fileNames, this.threeList[this.threeIndex].one, hall.m_product_tag, hall.m_industry_tag);

            if(files.length == 0){
                return;
            }else{
                this.downloadFileId = files;
                this.downloadFileName = fileNames;
                this.showDownloadPop();
                return;
            }
        },
        showDownloadPop(){
            this.downloadFilePop = true;
            this.email = this.$store.state.myData.email;
        },
        sendEmail(email){
            if(this.emailRequest){
                return;
            }
            this.emailRequest = true;

            // 埋码
            this.$maima.material_page_send_email_click(this.downloadFileName, this.threeList[this.threeIndex].one, email);

            let that = this;
            api.downloadWithEmail({
                fileList: that.downloadFileId,
                email: email
            }).then(res=>{
                if(res.result == 0){
                    that.downloadFilePop = false;
                    that.showDownloadFileSuccess();
                    that.downloadFileId = [];
                    that.downloadFileName = '';
                }else{
                    that.downloadFilePopMsg = res.desc;
                }
                that.emailRequest = false;
            })
            .catch(err=>{
                that.$store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                that.emailRequest = false;
            });
        },
        showDownloadFileSuccess(){
            this.downloadFileSuccessPop = true;
        },
        downloadFilePopClose(){
            this.downloadFileSuccessPop = false;
        },
        closeDownLoadPop(){
            this.downloadFilePop=false
        },
        showPop(){
            return;
        },
        getFiles(folderId){
            let that = this;
            api.getFileFolder(folderId)
            .then(res=>{
                if(res.length > 0){
                    that.info.fileList = res;
                }
            })
            .catch(err=>{
            });

        },
    },
}
</script>
<style scoped lang="scss">
*{
    box-sizing: border-box ;
    padding: 0;
    margin: 0;
}
.flex{
    display: flex;
}
.pc{
    position: relative;
    width: 100vw;
    height: 100vh;
    overflow: hidden;                                                                                                      
    background: url('../assets/newImages/common/common-bg.png') no-repeat center center/cover;
    .right-bg{
        position: absolute;
        bottom: 0;
        right: 0;
        width: pxToVw(480);
        height: pxToVw(403);
        img{
            width: 100%;
        }
    }
    .content{
        width: pxToVw(1600);
        margin-left: pxToVw(233);//87
        padding-top: pxToVw(49);
        .con-header{
            width: 100%;
            height: pxToVw(115);
            margin-bottom: pxToVw(21);
            p{  
                width: pxToVw(351);
                height: pxToVw(115);
                padding: pxToVw(39) 0 0 pxToVw(92);
                font-size: pxToVw(43);
                font-family: "FZLT-blackBold";
                color: #FFF;
                line-height: pxToVw(52);
                background: url("../assets/newImages/common/common-title-bg.png")no-repeat center center/cover;
            }
        }
        // tab，筛选，搜索
        .con-main{
            width: pxToVw(1540);
            margin-left: pxToVw(60);
            padding-top: pxToVw(67);
            position: relative;
            .main-top{
                width: 100%;
                height: pxToVw(80);
                position: absolute;
                top: 0;left: 0;
                z-index: 2;
                padding-right: pxToVw(17);
                display: flex;
                justify-content: space-between;
                .main-three{
                    width: pxToVw(689);
                    height: pxToVw(80);
                    padding: 0 pxToVw(7);
                    background: #FFFFFF;
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    justify-content: space-between;
                    box-shadow: 0px 2px pxToVw(5) 0px rgba(234,234,234,0.5);
                    border-radius: 2px pxToVw(30) 2px pxToVw(30);
                    .three{
                        position: relative;
                        width: pxToVw(225);
                        height: pxToVw(80);
                        &:nth-child(3){
                            .line{
                                display: none;
                            }
                        }
                        .line{
                            position: absolute;
                            top: pxToVw(20);
                            right: 0;
                            width: 1px;
                            height: pxToVw(40);
                            background: #949494;
                            opacity: 0.3;
                        }
                        p{
                            font-size: pxToVw(27);
                            font-family: "FZLT-blackLittle";
                            color: #333333;
                            text-align: center;
                            line-height: pxToVw(38);
                            text-shadow: 0 pxToVw(3) pxToVw(5) rgba(234, 234, 234, 0.5);
                        }
                        span{
                            display: none;
                            position: absolute;
                            bottom: pxToVw(-2);
                            left: 50%;
                            width: pxToVw(40);
                            transform: translateX(-50%);
                            height: pxToVw(4);
                            background: #C50819;
                            border-radius: pxToVw(5);
                        }
                    }
                    .three-active{
                        p{
                            color: #C50819;
                        }
                        span{
                            display: block;
                        }
                    }
                }
                .right{
                    display: flex;
                    height: pxToVw(40);
                    margin-top: pxToVw(11);
                  .input-div{
                        width: pxToVw(316);
                        height: pxToVw(40);
                        background: rgba($color: #FFF, $alpha: 0.9);
                        box-shadow: 0px 0px pxToVw(27) 0px rgba(231,231,231,0.5);
                        border-radius: pxToVw(23);
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 0 pxToVw(16) 0 pxToVw(33);
                        input{
                            width: pxToVw(225);
                            height: pxToVw(40);
                            font-size: pxToVw(19);
                            color: #333;
                            line-height: pxToVw(23);
                            border: none;
                            background: none;
                            &::placeholder{
                                color: #AAA;
                            }
                        }
                        .search{
                            width: pxToVw(40);
                            height: pxToVw(40);
                            padding: pxToVw(10);
                            cursor: pointer;
                            img{
                                vertical-align: top;
                                width: pxToVw(21);
                                height: pxToVw(21);
                            }
                        }
                    }
                    .box{
                        height: auto;
                        display: flex;
                        align-items: center;
                        .screen-right{
                            // width: pxToVw(80);
                            display: flex;
                            align-items: center;
                            margin-left: pxToVw(16);
                            cursor: pointer;
                            p{
                                font-size: pxToVw(19);
                                font-weight: normal;
                                color: #999999;
                                line-height: pxToVw(23);
                                margin-right: pxToVw(10);
                            }
                            img{
                                width: pxToVw(17);
                                height: pxToVw(9);
                                vertical-align: top;
                                transform: rotate(180deg);  
                            }
                        }
                        .screen-active{
                            p{
                                color: #C50819;
                            }
                            img{
                                width: pxToVw(17);
                                height: pxToVw(9);
                                transform: rotate(0);
                            }
                        }   
                    }
                    
                }
                
            }
        }
        // 资料内容
        .main{
            width: 100%;
            padding-right: pxToVw(20);
            .main-list{
                width: 100%;
                height: 100%;
                position: relative;
                background: rgba(255, 255, 255, 0.9);
                padding: pxToVw(20) 0;
                box-shadow: 0px 0px pxToVw(27) 0px rgba(231,231,231,0.5);
                border-radius: pxToVw(3);
                .main-list-one{
                    position: relative;
                    width: pxToVw(1540);
                    height: 100%;
                    padding: pxToVw(65) 0 0 pxToVw(30);
                    overflow-y: scroll;
                    scrollbar-width: none;
                    -ms-overflow-style: none;
                    &::-webkit-scrollbar{
                        width: 3px;
                        height: 100%;
                        background: none;
                    }
                    &::-webkit-scrollbar-track{
                        background: none;
                    }
                    &::-webkit-scrollbar-thumb{
                        background: rgba(221, 221, 221, 0.6);
                    }
                    .one-list1{
                        width: pxToVw(1445);
                        height: auto;
                        margin-bottom: pxToVw(27);
                        &:last-child{
                            .pdf{
                                border-bottom: none;
                            }
                        } 
                        .title{
                            width: pxToVw(1445);
                            height: pxToVw(37);
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            cursor: pointer;
                            .left{
                                display: flex;
                                p{
                                    &:nth-child(1){
                                        width: pxToVw(4);
                                        height: pxToVw(21);
                                        background: #C50819;
                                        border-radius: pxToVw(3);
                                    }
                                    &:nth-child(2){
                                        font-size: pxToVw(21);
                                        font-family: "FZLT-blackLittle";
                                        font-weight: normal;
                                        color: #333333;
                                        line-height: pxToVw(25);
                                        margin-left: pxToVw(10);
                                    }
                                }
                                
                            }
                            .right{
                                display: flex;
                                align-items: center;
                                .r-button{
                                    width: pxToVw(159);
                                    height: pxToVw(37);
                                    background: #FFFFFF;
                                    border-radius: pxToVw(19);
                                    border: 1px solid #C50819;
                                    padding-left: pxToVw(20);
                                    display: flex;
                                    align-items: center;
                                    .r-img{
                                        width: pxToVw(27);
                                        height: pxToVw(23);
                                        img{
                                            width: 100%;
                                            vertical-align: top;
                                        }
                                    }
                                    p{
                                        font-size: pxToVw(19);
                                        font-weight: normal;
                                        color: #C50819;
                                        line-height: pxToVw(23);
                                        margin-left: pxToVw(8);
                                    }
                                }
                                .r-button2{
                                    margin-left: pxToVw(40);
                                    width: pxToVw(17);
                                    height: pxToVw(9);
                                    cursor: pointer;

                                    img{
                                        vertical-align: top;
                                        width: 100%;
                                    }
                                } 
                                .more-active{
                                    img{
                                        transform: rotate(180deg);
                                    }
                                }  
                            }
                        }
                        .pdf{
                            display: flex;
                            flex-direction: column;
                            padding-bottom: pxToVw(40);
                            border-bottom: 3px solid RGBA(237, 237, 237, .7);
                            height: auto;
                            .item{
                                width: pxToVw(1443);
                                height: pxToVw(91);
                                background: #FFFFFF;
                                box-shadow: 0px 0px 11px 0px rgba(235,235,235,0.5);
                                border-radius: 0px 0px 3px 3px;
                                margin-top: pxToVw(19);
                                padding: 0 pxToVw(50);
                                display: flex;
                                .item-left{
                                    width: pxToVw(1090);
                                    display: flex;
                                    align-items: center;
                                    .left{
                                        width: pxToVw(35);
                                        height: pxToVw(28);
                                        img{
                                            width: 100%;
                                            vertical-align: top;
                                        }
                                    }
                                    .left3{
                                        width: pxToVw(29);
                                        height: pxToVw(31);
                                        img{
                                            width: 100%;
                                            vertical-align: top;
                                        }
                                    }
                                    p{
                                        width: pxToVw(1000);
                                        font-size: pxToVw(19);
                                        font-weight: normal;
                                        color: #333333;
                                        line-height: pxToVw(23);
                                        margin-left: pxToVw(30);
                                        overflow:hidden;
                                        white-space: nowrap;
                                        text-overflow: ellipsis;
                                        -o-text-overflow:ellipsis;
                                    }
                                }
                                .item-right{
                                    width: pxToVw(249);
                                    display: flex;
                                    align-items: center;
                                    .right-but{
                                        display: flex;
                                        align-items: center;
                                        cursor: pointer;
                                        width: pxToVw(110);
                                        margin-right: pxToVw(29);
                                        &:nth-child(2){
                                            margin-right: 0;
                                        }
                                        .but-img{
                                            width: pxToVw(25);
                                            height: pxToVw(23);
                                            img{
                                                width: 100%;
                                                vertical-align: top;
                                            }
                                        }
                                        .but-img2{
                                            width: pxToVw(28);
                                            height: pxToVw(23);
                                            img{
                                                width: 100%;
                                                vertical-align: top;
                                            }
                                        }
                                        p{
                                            // width: ;
                                            font-size: pxToVw(16);
                                            font-weight: normal;
                                            color: #666666;
                                            line-height: pxToVw(19);
                                            margin-left: pxToVw(10);
                                        }
                                    }
                                }
                            }
                           
                        }
                        
                    }
                }
            }
        }
        // 专题演讲筛选
        .screen-main{
            position: absolute;
            z-index: 9;
            top: pxToVw(72);
            left: 0;
            width: pxToVw(1523);
            height: auto;
            padding: 0 pxToVw(93) pxToVw(92);
            background: #FFFFFF;
            box-shadow: 0 0 pxToVw(27) 0 rgba(231,231,231,0.5);
            .screen-bg{
                position: absolute;
                bottom: 0;left: 0;
                z-index: -1;
                width: pxToVw(399);
                height: pxToVw(147);
                img{
                    width: pxToVw(399);
                    height: pxToVw(147);
                }
            }
            .title{
                padding: pxToVw(53) 0 pxToVw(29) 0;
                height: pxToVw(108);
                display: flex;
                margin-bottom: pxToVw(20);
                border-bottom: 1px solid #EEEEEE;
                .red-line{
                    width: pxToVw(4);
                    height: pxToVw(20);
                    background: #C50819;
                    margin-right: pxToVw(18);
                }
                p{
                    font-size: pxToVw(21);
                    color: #333333;
                    font-family: "FZLT-blackBold";
                    line-height: pxToVw(25);
                }
            }
            .content-main{
                width: 100%;
                height: auto;
                overflow-y: scroll;
                scrollbar-width: none;
                -ms-overflow-style: none;
                &::-webkit-scrollbar{
                    width: 3px;
                    height: 100%;
                    background: none;
                }
                &::-webkit-scrollbar-track{
                    background: none;
                }
                &::-webkit-scrollbar-thumb{
                    background: rgba(221, 221, 221, 0.6);
                }
            }
            .title-line{
                width: 100%;
                display: flex;
                .text-name{
                    width: pxToVw(150);
                    margin-right: pxToVw(70);
                    font-size: pxToVw(19);
                    font-family: "FZLT-blackLittle";
                    color: #666666;
                    line-height: pxToVw(63);
                }
                .choose-nav{
                    width: pxToVw(1110);
                    padding-top: pxToVw(20);
                    display: flex;
                    flex-wrap: wrap;
                    .choose-nav-one{
                        width: pxToVw(160);
                        height: pxToVw(23);
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        margin: 0 pxToVw(30) pxToVw(20) 0;
                        .img{
                            width: pxToVw(20);
                            height: pxToVw(20);
                            margin-right: pxToVw(16);
                            img{
                                vertical-align: top;
                                width: pxToVw(20);
                                height: pxToVw(20);
                            }
                        }
                        p{
                            font-size: pxToVw(19);
                            color: #666666;
                            line-height: pxToVw(23);
                        }
                    }
                }
            }
            .button-line{
                margin-top: pxToVw(41);
                padding-left: pxToVw(447);
                display: flex;
                .button{
                    width: pxToVw(200);
                    height: pxToVw(53);
                    cursor: pointer;
                    margin-right: pxToVw(40);
                    background: #C50819;
                    font-size: pxToVw(19);
                    color: #FFF;
                    text-align: center;
                    line-height: pxToVw(53);
                    border-radius: 3px;
                    &:first-child{
                        border: 1px solid #C50819;
                        color: #C50819;
                        background: #FFF;
                    }
                    // img{
                    //     vertical-align: top;
                    //     width: pxToVw(200);
                    //     height: pxToVw(53);
                    // }
                }
            }
        }
        // 展厅筛选
        .screen-main2{
            position: absolute;
            z-index: 9;
            top: pxToVw(72);
            right: pxToVw(25);
            width: pxToVw(661);
            // height: auto;
            // padding: 0 pxToVw(93) pxToVw(53);
            background: #FFFFFF;
            box-shadow: 0 0 pxToVw(27) 0 rgba(231,231,231,0.5);
            .bg{
                position: absolute;
                bottom: 0;left: 0;
                z-index: -1;
                width: pxToVw(204);
                height: pxToVw(155);
                img{
                    width: pxToVw(204);
                    height: pxToVw(155);
                }
            }
            .title{
                padding: pxToVw(53) 0  0 pxToVw(93);
                height: pxToVw(108);
                display: flex;
                margin-bottom: pxToVw(39);
                border-bottom: 1px solid #EEEEEE;
                .red-line{
                    width: pxToVw(4);
                    height: pxToVw(20);
                    background: #C50819;
                    margin-right: pxToVw(18);
                }
                    p{
                        font-size: pxToVw(21);
                        color: #333333;
                        font-family: "FZLT-blackBold";
                        line-height: pxToVw(25);
                    }
            }
            .content-main2{
                width: 100%;
                height: auto;
                overflow-y: scroll;
                scrollbar-width: none;
                -ms-overflow-style: none;
                display: flex;
                padding-left:pxToVw(116);
                justify-content: space-around;
                &::-webkit-scrollbar{
                    width: 3px;
                    height: 100%;
                    background: none;
                }
                &::-webkit-scrollbar-track{
                    background: none;
                }
                &::-webkit-scrollbar-thumb{
                    background: rgba(221, 221, 221, 0.6);
                }
                   .choose-one{
                        width: pxToVw(160);
                        height: pxToVw(23);
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        // margin: 0 pxToVw(109) pxToVw(20) 0;
                        .one-img{
                            width: pxToVw(20);
                            height: pxToVw(20);
                            margin-right: pxToVw(16);
                            img{
                                vertical-align: top;
                                width: pxToVw(20);
                                height: pxToVw(20);
                            }
                        }
                        p{
                            font-size: pxToVw(19);
                            color: #666666;
                            line-height: pxToVw(23);
                        }
                    } 
            }
            .button-line{
                margin: pxToVw(67) 0 pxToVw(53);
                padding-left: pxToVw(111);
                display: flex;
                .submit{
                    width: pxToVw(200);
                    height: pxToVw(53);
                    cursor: pointer;
                    margin-right: pxToVw(40);
                    background: #C50819;
                    font-size: pxToVw(19);
                    color: #FFF;
                    text-align: center;
                    line-height: pxToVw(53);
                    border-radius: 3px;
                    &:first-child{
                        border: 1px solid #C50819;
                        color: #C50819;
                        background: RGBA(255, 255, 255, .1);
                    }
                    // img{
                    //     vertical-align: top;
                    //     width: pxToVw(200);
                    //     height: pxToVw(53);
                    // }
                }
            }
        }
    }
}
.wap{
    display: none;
}
@media screen and (max-width:767px) {
    .pc{
        display: none;
    }
    .wap{
        display: block;
        position: relative;
        z-index: 2;
        width: 100%;
        height: auto;
        min-height: 100vh;
        padding: 10vw 0 12.7vw;
        background: url('../assets/newImages/exhibitionGuide/wap-bg.png')no-repeat center center/cover;
        .page-img{
            position: absolute;
            bottom: 0;
            z-index: -1;
            right: 0;
            width: 38.1vw;
            height: 25.1vw;
            img{
                width: 38.1vw;
                height: 25.1vw;
            }
        }
        .content{
            width: 100%;
            border-top: 1px solid #DDDDDD;
            .con-header{
                height: 12.3vw;
                margin: 3.2vw 0 2.3vw;
                width: 100%;
                text-align: left;
                p{  
                    width: 37.6vw;
                    height: 12.3vw;
                    margin-left: -2.8vw;
                    padding: 4.1vw 0 0 10vw;
                    font-size: 4.3vw;
                    font-family: "FZLT-blackBold";
                    color: #FFF;
                    line-height: 5.2vw;
                    background: url("../assets/newImages/common/navWap/page-title.png") no-repeat center center/cover;
                }
            }
            .con-main{
                margin: 2.3vw auto 0;
                width: 91.5vw;
                height: auto;
                .main-top{
                    width: 100%;
                    .input-div{
                        width: 90.9vw;
                        height: 8vw;
                        background: #FFFFFF;
                        box-shadow: 0px 0px 4vw 0px rgba(231,231,231,0.5);
                        border-radius: 4vw;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 0 5vw 0 ;
                        input{
                            width: 70vw;
                            height: 8vw;
                            font-size: 3.2vw;
                            color: #333;
                            line-height: 3.6vw;
                            border: none;
                            background: none;
                            &::placeholder{
                                color: #AAA;
                            }
                        }
                        .search{
                            width: 3.1vw;
                            height: 3.1vw;
                            // padding: pxToVw(10);
                            // cursor: pointer;
                            img{
                                vertical-align: top;
                                width: 3.1vw;
                                height: 3.1vw;
                            }
                        }
                    }
                }
                .main-top2{
                    display: flex;
                    width: 100%;
                    .input-div{
                        width: 69.6vw;
                        height: 8vw;
                        background: #FFFFFF;
                        box-shadow: 0px 0px 4vw 0px rgba(231,231,231,0.5);
                        border-radius: 4vw;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 0 5vw 0 ;
                        input{
                            width: 53vw;
                            height: 8vw;
                            font-size: 3.2vw;
                            color: #333;
                            line-height: 3.6vw;
                            border: none;
                            background: none;
                            &::placeholder{
                                color: #AAA;
                            }
                        }
                        .search{
                            width: 3.1vw;
                            height: 3.1vw;
                            // padding: pxToVw(10);
                            // cursor: pointer;
                            img{
                                vertical-align: top;
                                width: 3.1vw;
                                height: 3.1vw;
                            }
                        }
                    }
                    .box{
                        height: auto;
                        display: flex;
                        align-items: center;
                        .screen-right{
                            // width: pxToVw(80);
                            display: flex;
                            align-items: center;
                            margin-left: 4.3vw;
                            p{
                                font-size: 3.2vw;
                                font-weight: normal;
                                color: #999999;
                                line-height: 3.6vw;
                                margin-right: 1.5vw;
                            }
                            img{
                                width: 2.8vw;
                                height: 1.7vw;
                                vertical-align: top;
                                transform: rotate(180deg);  
                            }
                        }
                        .screen-active{
                            p{
                                color: #C50819;
                            }
                            img{
                                width: 2.8vw;
                                height: 1.7vw;
                                transform: rotate(0);
                            }
                        }   
                    }
                }
                // 专题演讲筛选
                .screen-main{
                    position: absolute;
                    z-index: 9;
                    // top: 9.7vw;
                    // left: 0;
                    margin-top: 1.7vw;
                    width: 90.7vw;
                    height: auto;
                    padding: 4.1vw 0 9.5vw 2.7vw;
                    background: #FFFFFF;
                    box-shadow: 0px 0px 2.7vw 0px rgba(231,231,231,0.5);
                    .screen-bg{
                        position: absolute;
                        bottom: 0;left: 0;
                        z-index: -1;
                        width: 26.4vw;
                        height: 22.3vw;
                        img{
                            width: 26.4vw;
                            height: 22.3vw;
                        }
                    }
                    .title{
                        padding: 0 0 2.5vw 0;
                        height: pxToVw(108);
                        display: flex;
                        margin-bottom: pxToVw(20);
                        border-bottom: 1px solid #EEEEEE;
                        .red-line{
                            width: 0.7vw;
                            height: 3.2vw;
                            background: #C50819;
                            margin-right: 2.8vw;
                        }
                        p{
                            font-size: 3.5vw;
                            color: #333333;
                            font-family: "FZLT-blackBold";
                            line-height: 4.1vw;
                        }
                    }
                    .title-line{
                        width: 100%;
                        padding: 0 5.1vw;
                        .text-name{
                            font-size: 3.2vw;
                            font-family: "FZLT-blackLittle";
                            color: #666666;
                            line-height: 10.7vw;
                        }
                        .choose-nav{
                            width: 100%;
                            display: flex;
                            flex-wrap: wrap;
                            .choose-nav-one{
                                width: 30vw;
                                height: pxToVw(23);
                                cursor: pointer;
                                display: flex;
                                align-items: center;
                                margin: 0 4vw 3.2vw 0;
                                // &:nth-child(3n){
                                //     margin-right: 0;
                                // }
                                .img{
                                    width: 3.3vw;
                                    height: 3.3vw;
                                    margin-right: 2.5vw;
                                    img{
                                        vertical-align: top;
                                        width: 3.3vw;
                                        height: 3.3vw;
                                    }
                                }
                                p{
                                    font-size: 3.2vw;
                                    color: #666666;
                                    line-height: 3.6vw;
                                }
                            }
                        }
                    }
                    .button-line{
                        margin-top: 3.9vw;
                        padding-left: 1vw;
                        display: flex;
                        .button{
                            width: 32vw;
                            height: 8.5vw;
                            cursor: pointer;
                            margin-left: 6.4vw;
                            background: #C50819;
                            font-size: 3.4vw;
                            color: #FFF;
                            text-align: center;
                            line-height: 8.5vw;
                            border-radius: 3px;
                            &:first-child{
                                border: 1px solid #C50819;
                                color: #C50819;
                                background: rgba(255, 255, 255, .1);
                            }
                            // img{
                            //     vertical-align: top;
                            //     width: 32vw;
                            //     height: 8.5vw;
                            // }
                        }
                    }
                }
                // 展厅筛选
                .screen-main2{
                    position: absolute;
                    z-index: 9;
                    // top: 9.7vw;
                    // left: 0;
                    margin-top: 1.7vw;
                    width: 90.7vw;
                    // height: auto;
                    // padding: 0 pxToVw(93) pxToVw(53);
                    background: #FFFFFF;
                    box-shadow: 0 0 pxToVw(27) 0 rgba(231,231,231,0.5);
                    .bg{
                        position: absolute;
                        bottom: 0;left: 0;
                        z-index: -1;
                        width: 22vw;
                        height: 15.3vw;
                        img{
                            width: 22vw;
                            height: 15.3vw;
                        }
                    }
                    .title{
                        margin: 0vw 2.8vw 0;
                        padding: 4.1vw 0 0;
                        height: 10.8vw;
                        display: flex;
                        margin-bottom: 4.4vw;
                        border-bottom: 1px solid #EEEEEE;
                        .red-line{
                            width: 0.7vw;
                            height: 3.2vw;
                            background: #C50819;
                            margin-right: 2.8vw;
                        }
                            p{
                                font-size: 3.5vw;
                                color: #333333;
                                font-family: "FZLT-blackBold";
                                line-height: 4.1vw;
                            }
                    }
                    .content-main2{
                        width: 100%;
                        height: auto;
                        // overflow-y: scroll;
                        // scrollbar-width: none;
                        // -ms-overflow-style: none;
                        display: flex;
                        padding-left:8.3vw;
                        // justify-content: space-around;
                        // &::-webkit-scrollbar{
                        //     width: 3px;
                        //     height: 100%;
                        //     background: none;
                        // }
                        // &::-webkit-scrollbar-track{
                        //     background: none;
                        // }
                        // &::-webkit-scrollbar-thumb{
                        //     background: rgba(221, 221, 221, 0.6);
                        // }
                        .choose-one{
                                width: 12.1vw;
                                height: 3.6vw;
                                display: flex;
                                align-items: center;
                                margin: 0 15.2vw 0 0;
                                .one-img{
                                    width: 3.2vw;
                                    height: 3.2vw;
                                    margin-right: 2.5vw;
                                    img{
                                        vertical-align: top;
                                        width: 3.2vw;
                                        height: 3.2vw;
                                    }
                                }
                                p{
                                    font-size: 3.2vw;
                                    color: #666666;
                                    line-height: 3.6vw;
                                }
                            } 
                    }
                    .button-line{
                        margin: 8.1vw 0 10.8vw;
                        padding-left: 10.1vw;
                        display: flex;
                        .submit{
                            width: 32vw;
                            height: 8.5vw;
                            margin-right: 6.4vw;
                            background: #C50819;
                            font-size: 3.2vw;
                            color: #FFF;
                            text-align: center;
                            line-height: 8.5vw;
                            border-radius: 3px;
                            &:first-child{
                                border: 1px solid #C50819;
                                color: #C50819;
                                background: RGBA(255, 255, 255, .1);
                            }
                            // img{
                            //     vertical-align: top;
                            //     width: pxToVw(200);
                            //     height: pxToVw(53);
                            // }
                        }
                    }
                }
                //tab
                .main-three{
                        width: 90.9vw;
                        height: 10.7vw;
                        padding: 0 4.3vw 0 3.5vw;
                        margin-top: 2.7vw;
                        background: #FFFFFF;
                        display: flex;
                        align-items: center;
                        // justify-content: space-between;
                        box-shadow: 0px 0.3vw 0.7vw 0px rgba(234,234,234,0.5);
                        border-radius: 2vw 4.5vw 2vw 4.5vw;
                        .three{
                            position: relative;
                            width: 28.7vw;
                            height: 10.7vw;
                            &:nth-child(3){
                                .line{
                                    display: none;
                                }
                            }
                            .line{
                                position: absolute;
                                top: 3.1vw;
                                right: 0;
                                z-index: 6;
                                width: 2px;
                                height: 4.5vw;
                                background: #949494;
                                opacity: 0.3;
                            }
                            p{
                                font-size: 4vw;
                                font-family: "FZLT-blackLittle";
                                color: #333333;
                                text-align: center;
                                line-height: 4.6vw;
                                text-shadow: 0 0.3vw 0.7vw rgba(234, 234, 234, 0.5);
                            }
                            span{
                                display: none;
                                position: absolute;
                                bottom: -0.2vw;
                                left: 50%;
                                width: 4.5vw;
                                transform: translateX(-50%);
                                height: 0.7vw;
                                background: #C50819;
                                border-radius: 0.5vw;
                            }
                        }
                        .three-active{
                            p{
                                color: #C50819;
                            }
                            span{
                                display: block;
                            }
                        }
                }
                // 资料内容
                .main{
                    width: 100%;
                    margin-top: 4.5vw;
                    .main-list{
                        width: 100%;
                        height: 100%;
                        position: relative;
                        .main-list-one{
                            position: relative;
                            width: 100%;
                            height: 100%;
                            .one-list1{
                                width: 100%;
                                height: auto;
                                margin-bottom: 3.2vw;
                                padding: 4vw 0;
                                border-bottom: 1px solid #EEEEE0;
                                &:last-child{
                                    margin-bottom:0;
                                } 
                                .title{
                                    width: 91.5vw;
                                    height: 5.6vw;
                                    display: flex;
                                    justify-content: space-between;
                                    align-items: center;
                                    cursor: pointer;
                                    .left{
                                        display: flex;
                                        p{
                                            &:nth-child(1){
                                                width: 0.6vw;
                                                height: 3.2vw;
                                                background: #C50819;
                                                border-radius: 0.4vw;
                                            }
                                            &:nth-child(2){
                                                width: 53.9vw;
                                                font-size: 3.2vw;
                                                font-family: "FZLT-blackLittle";
                                                font-weight: normal;
                                                color: #333333;
                                                line-height: 3.7vw;
                                                margin-left: 1.2vw;
                                                overflow:hidden;
                                                white-space: nowrap;
                                                text-overflow: ellipsis;
                                            }
                                        }
                                        
                                    }
                                    .right{
                                        display: flex;
                                        align-items: center;
                                        .r-button{
                                            width: 23.8vw;
                                            height:5.6vw;
                                            background: #FFFFFF;
                                            border-radius: 2.8vw;
                                            border: 1px solid #C50819;
                                            padding-left: 2.9vw;
                                            display: flex;
                                            align-items: center;
                                            .r-img{
                                                width: 4.1vw;
                                                height: 3.2vw;
                                                img{
                                                    width: 100%;
                                                    vertical-align: top;
                                                }
                                            }
                                            p{
                                                font-size: 2.8vw;
                                                font-weight: normal;
                                                color: #C50819;
                                                line-height: 3.2vw;
                                                margin-left: 1.3vw;
                                            }
                                        }
                                        .r-button2{
                                            margin-left: 3.9vw;
                                            width: 4.2vw;
                                            height: 2.1vw;
                                            img{
                                                vertical-align: top;
                                                width: 100%;
                                            }
                                        } 
                                        .more-active{
                                            img{
                                                transform: rotate(180deg);
                                            }
                                        }  
                                    }
                                }
                                .pdf{
                                    display: flex;
                                    flex-direction: column;
                                    height: auto;
                                    .item{
                                        width: 91.5vw;
                                        height: 24vw;
                                        background: #FFFFFF;
                                        box-shadow: 0px 0px 1.1vw 0px rgba(235,235,235,0.5);
                                        border-radius: 0px 0px 0.3vw 0.3vw;
                                        margin-top: 2.7vw;
                                        padding: 3.3vw 5vw 2vw;
                                        display: flex;
                                        flex-direction: column;
                                        .item-left{
                                            display: flex;
                                            // align-items: center;
                                            .left{
                                                width: 5.2vw;
                                                height: 4.1vw;
                                                img{
                                                    width: 100%;
                                                    vertical-align: top;
                                                }
                                            }
                                            .left3{
                                                width: 4.4vw;
                                                height: 4.7vw;
                                                img{
                                                    width: 100%;
                                                    vertical-align: top;
                                                }
                                            }
                                            p{
                                                width: 70vw;
                                                height: 9.6vw;
                                                font-size: 3.5vw;
                                                font-weight: normal;
                                                color: #333333;
                                                line-height: 4.8vw;
                                                margin-left: 4.7vw;
                                                overflow: hidden;
                                                text-overflow: ellipsis;
                                                display: -webkit-box;
                                                -webkit-line-clamp: 2;
                                                -webkit-box-orient: vertical;
                                            }
                                        }
                                        .item-right{
                                            // width: pxToVw(249);
                                            display: flex;
                                            align-items: center;
                                            margin:3.7vw 0vw 0 9.9vw;
                                            .right-but{
                                                width: 20vw;
                                                margin-right: 1.5vw;
                                                display: flex;
                                                align-items: center;
                                                &:nth-child(2){
                                                    margin-right: 0;
                                                }
                                                .but-img{
                                                    width: 3.6vw;
                                                    height: 3.3vw;
                                                    img{
                                                        width: 100%;
                                                        vertical-align: top;
                                                        margin-top: -0.2vw;
                                                    }
                                                }
                                                .but-img2{
                                                    width: 4.1vw;
                                                    height: 3.3vw;
                                                    img{
                                                        width: 100%;
                                                        vertical-align: top;
                                                        margin-top: -0.2vw;
                                                    }
                                                }
                                                p{
                                                    width: 14vw;
                                                    font-size: 3.2vw;
                                                    font-weight: normal;
                                                    color: #666666;
                                                    line-height: 3.6vw;
                                                    margin-left: 2vw;
                                                }
                                            }
                                        }
                                    }
                                
                                }
                                
                            }
                        }
                        .main-list-one-div{
                            width: 100%;
                            height: 50vh;
                            background: #FFF;
                        }
                    }
                }
            }
        }
    }
}
</style>